import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  topRow: {
    width: '100%',
    height: '50%',
    backgroundColor: 'white',
    color: '#27343d',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
  },
  bottomRow: {
    width: '100%',
    height: '50%',
    backgroundColor: '#27343d',
    color: 'white',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingHorizontal: 53,
  },

  about: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.3,
    marginTop: 20,
    marginBottom: 40,
    width: '90%',
  },
  citationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '50%',
    height: '100%',
    paddingRight: 20,
  },
  citation: {
    fontFamily: 'Lato',
    fontSize: 32,
    fontWeight: 900,
    textAlign: 'left',
    width: '90%',
  },
  speakerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginTop: 30,
  },
  getReady: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 400,
    textAlign: 'left',
  },

  image1: {
    position: 'absolute',
    top: 53,
    left: '47%',
    width: 420,
    height: 680,
    objectFit: 'contain',
    borderRadius: '15px',
  },
  image2: {
    position: 'absolute',
    top: 20,
    left: '78%',
    width: 260,
    height: 290,
    objectFit: 'cover',
    borderRadius: '15px',
  },
  image3: {
    position: 'absolute',
    top: 340,
    left: '78%',
    width: 260,
    height: 350,
    objectFit: 'cover',
    borderRadius: '15px',
  },
});
